import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { MypageState } from '@/store/mypage/types'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const Mypage: Module<MypageState, RootState> = {
  state: {
    lessonSchedules: [],
    lessons: [],
    informations: [],
    toDoApplications: [],
    toDoWaitingApproveds: [],
    toDoDeadlines: [],
    events: [],
    announces: [],
  },
  actions,
  mutations,
  getters,
}

export default Mypage
